import { useLocation } from 'react-router'
import queryString from 'query-string'

export const useQueryParams = () => {
  const location = useLocation()

  return queryString.parse(location.search, { arrayFormat: 'comma' })
}
